import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  slot: "dialog-body",
  class: "country-slice",
  "aria-label": "locale-selection"
}
const _hoisted_2 = { class: "countries" }
const _hoisted_3 = ["data-heap", "onClick"]
const _hoisted_4 = ["data-heap", "onClick"]

import {getSliceComponentProps, PrismicRichText} from '@prismicio/vue';
    import {inject, ref, onMounted} from 'vue';
    import {CountrySliceSlice} from '@/unlogged/prismicio';
    import {Country} from '@/unlogged/composables/useCountry';
    import OptimizedImage from '@/unlogged/components/OptimizedImage.vue';
    import {RESET_SELECTED_HOST, USER_LOCALE} from '@/unlogged/keys';

    type Lang = {
        langKey: string;
        langName: string;
        heapId: string | undefined;
    };

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CountrySlice',
  props: {
        ...getSliceComponentProps<CountrySliceSlice>(),
    },
  setup(__props) {

const props = __props;

    

    const locale = inject(USER_LOCALE);

    const selectedCountry = ref<Country>();
    const selectedLang = ref<Lang | null>();

    function setSelectedFromLocale() {
        if (locale) {
            const [currentLang, currentCountryCode] = locale.split('-');
            selectedCountry.value = props.slice.items.find((item) => item.countryKey?.toUpperCase() === currentCountryCode?.toUpperCase());
            selectedLang.value = selectedCountryLanguages().find((lang) => lang.langKey.toUpperCase() === currentLang?.toUpperCase());
        }
    }

    const onDialogShowCallBack = inject(RESET_SELECTED_HOST);
    onDialogShowCallBack && (onDialogShowCallBack.value = setSelectedFromLocale);

    onMounted(setSelectedFromLocale);

    function setSelectedCountry(country: Country) {
        selectedCountry.value = country;
        selectedLang.value = null;
    }

    function setSelectedLang(lang: Lang) {
        selectedLang.value = lang;
    }

    async function goToCountryUrl(lang: Lang, country: Country) {
        const newLocale = `${lang.langKey?.toLowerCase()}-${country.countryKey?.toLowerCase()}`;
        const newUrl = new window.URL(location.href);
        newUrl.searchParams.set('lg', newLocale);
        window.location.href = newUrl.href;
    }

    function isLang(object: any): object is Lang {
        return !!object.langKey && !!object.langName;
    }

    function selectedCountryLanguages(): Lang[] {
        return [
            {
                langKey: selectedCountry?.value?.lang1Key,
                langName: selectedCountry?.value?.lang1Name,
                heapId: selectedCountry?.value?.lang1HeapId,
            },
            {
                langKey: selectedCountry?.value?.lang2Key,
                langName: selectedCountry?.value?.lang2Name,
                heapId: selectedCountry?.value?.lang2HeapId,
            },
            {
                langKey: selectedCountry?.value?.lang3Key,
                langName: selectedCountry?.value?.lang3Name,
                heapId: selectedCountry?.value?.lang3HeapId,
            },
        ].filter(isLang);
    }

return (_ctx: any,_cache: any) => {
  const _component_joy_button = _resolveComponent("joy-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(PrismicRichText), {
      slot: "dialog-header",
      role: "banner",
      class: "country-slice__header",
      field: _ctx.slice.primary.countrySelectionTitle
    }, null, 8, ["field"]),
    _createVNode(_unref(PrismicRichText), {
      slot: "dialog-subheader",
      role: "contentinfo",
      field: _ctx.slice.primary.description
    }, null, 8, ["field"]),
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slice.items, (country, i) => {
          return (_openBlock(), _createElementBlock("button", {
            key: `slice-country-${i}`,
            type: "button",
            class: _normalizeClass({selected: country.countryKey === selectedCountry.value?.countryKey}),
            "data-heap": country.countryHeapId,
            onClick: ($event: any) => (setSelectedCountry(country))
          }, [
            _createVNode(OptimizedImage, {
              "prismic-image": country.countryIcon,
              height: "14",
              width: "14",
              alt: `${country.countryKey} flag`
            }, null, 8, ["prismic-image", "alt"]),
            _createElementVNode("span", null, _toDisplayString(`${country.countryName}`), 1)
          ], 10, _hoisted_3))
        }), 128))
      ]),
      _createVNode(_unref(PrismicRichText), {
        field: _ctx.slice.primary.langSelectionTitle,
        class: _normalizeClass(["lang-header", {
                hidden: selectedCountry.value === null,
            }])
      }, null, 8, ["field", "class"]),
      _createElementVNode("div", {
        class: _normalizeClass(["langs", {
                hidden: selectedCountry.value === null,
            }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedCountryLanguages(), (lang, i) => {
          return (_openBlock(), _createElementBlock("button", {
            key: `slice-lang-${i}`,
            type: "button",
            class: _normalizeClass({
                    selected: lang.langKey === selectedLang.value?.langKey,
                }),
            "data-heap": lang.heapId,
            onClick: ($event: any) => (setSelectedLang(lang))
          }, [
            _createElementVNode("span", null, _toDisplayString(`${lang.langName} (${lang.langKey})`), 1)
          ], 10, _hoisted_4))
        }), 128))
      ], 2)
    ]),
    _createVNode(_component_joy_button, {
      slot: "dialog-confirm",
      disabled: !selectedCountry.value || !selectedLang.value,
      onClick: _cache[0] || (_cache[0] = ($event: any) => (goToCountryUrl(selectedLang.value!, selectedCountry.value!)))
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.slice.primary.saveButtonText), 1)
      ]),
      _: 1
    }, 8, ["disabled"])
  ], 64))
}
}

})